export const toggle_modal = (toggle, reg_type) => ({
    type: "TOGGLE_MODAL",
    toggle,
    reg_type
});